/*
 * View for actions page
 */

define(["marionette", "modules/actions/template/actionsTemplate.html"], function (
  Marionette,
  ActionsTemplate,
) {
  var ActionsView = {};

  ActionsView.actionsLayout = Marionette.Layout.extend({
    template: ActionsTemplate,
    regions: {
      actionGroupsList: "#actionGroupsList",
      actionGroup: "#actionGroup",
    },
    triggers: {
      "click #addActionGroup": "add:group",
    },
  });

  return ActionsView;
});
